import store from '../reducers/storeRegistration';
import reportActionCreators from '../actions/reportActionCreators';
import issueActionCreators from '../actions/issueActionCreators';
import jobActionCreators from '../actions/jobActionCreators';
import formActionCreators from '../actions/formActionCreators';
import { evaluateSource } from '../../behaviors/src/lib/evaluateSource';
const actionCreators = {
  reportActionCreators,
  issueActionCreators,
  jobActionCreators,
  formActionCreators
};
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions) => {
  const uuid = await evaluateSource(source.uuid, content, parentContentPath, transientContext, nativeFunctions);
  if (uuid === undefined) {
    return undefined;
  }
  const entityActions = actionCreators["".concat(entityName, "ActionCreators")];
  const result = await store.dispatch(entityActions.serverShow(uuid));
  return result;
};
export default {
  evaluate
};